<template>
  <div class="dashboard">
    <v-navigation-drawer fixed dark v-model="sideNav" width="230" class="tow-saclor-1" app
      value="true">
      <div class="ml-5 mb-1 mt-2 hidden-lg-only">
       <!--  <img  class="logo" small src="/static/logo3.png"/> -->

      </div>
      <v-divider></v-divider>

      <v-list>
        <v-list-tile class="hidden-lg-only">
          <div class="">
            <v-flex xs12 class=" mr-3 ml-3 searchBox">
              <v-select
               dark
                  solo
                  prepend-inner-icon="g_translate"
                  background-color="white"
                  class="text-grey f-12"
                  v-model="selectedLanguage"
                  @change="changeLanguage(selectedLanguage)"
                  :items="items"
                  item-text="language"
                  item-value="abbr"
                  label="Select"
              ></v-select>
            </v-flex>
          </div>
        </v-list-tile>
        <v-list-tile to="/">
          <v-list-tile-action class="text-white">
            <v-icon>fas fa-tachometer-alt</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white">{{$t('layout.menus[0]')}}</v-list-tile-title>
        </v-list-tile>

        <!--<v-list-tile to="/widset">-->
          <!--<v-list-tile-action class="text-white">-->
            <!--<v-icon class="white&#45;&#45;text f-10">fa-credit-card</v-icon>-->
          <!--</v-list-tile-action>-->
          <!--<v-list-tile-title class="text-white">Widset</v-list-tile-title>-->
        <!--</v-list-tile>-->
        <v-list-tile to="/admincalender">
          <v-list-tile-action class="text-white">
            <!-- <v-icon class="white--text f-10">event</v-icon> -->
           <v-icon class="white--text f-10">far fa-calendar-alt</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white">{{$t('layout.menus[1]')}}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/totalearnings">
          <v-list-tile-action class="text-white">
            <v-icon class="white--text f-10">fa-credit-card</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white">{{$t('layout.menus[2]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-group prepend-icon="fas fa-graduation-cap">
          <v-list-tile class="text-white" slot="activator">
            <v-list-tile-title class="text-white">{{$t('layout.menus[3]')}}</v-list-tile-title>
          </v-list-tile>

            <v-list-tile  to="/students" class="pl-2">
              <v-list-tile-action>
                <v-icon class="text-white"> people</v-icon>
              </v-list-tile-action>
              <v-list-tile-title class="text-white f-12">{{$t('layout.menus[4]')}}</v-list-tile-title>
            </v-list-tile>

          <!--<v-list-tile  to="/bookclass" class="pl-2">-->
            <!--<v-list-tile-action>-->
              <!--<v-icon class="text-white"> alarm</v-icon>-->
            <!--</v-list-tile-action>-->
            <!--<v-list-tile-title class="text-white f-12">Book Classes</v-list-tile-title>-->
          <!--</v-list-tile>-->

            <v-list-tile to="/addnewstudent" class="pl-2">
            <v-list-tile-action>
              <!-- <v-icon class="text-white">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
            </v-list-tile-action>
              <v-list-tile-title class="white--text f-12">{{$t('layout.menus[5]')}}</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

        <v-list-group prepend-icon="people">
          <v-list-tile class="text-white" slot="activator">
            <v-list-tile-title class="text-white">{{$t('layout.menus[6]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/teachers" class="pl-2">
            <v-list-tile-action>
              <v-icon class="white--text">contacts</v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="white--text f-12">{{$t('layout.menus[7]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/addnewteacher" class="pl-2">
            <v-list-tile-action>
              <!-- <v-icon class="white--text">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
            </v-list-tile-action>
            <v-list-tile-title class="white--text f-12">{{$t('layout.menus[8]')}}</v-list-tile-title>
          </v-list-tile>

        </v-list-group>

        <v-list-group prepend-icon="class">
          <v-list-tile class="text-white" slot="activator">
            <!--<v-icon class="material-icons">class</v-icon>-->
            <v-list-tile-title class="text-white">{{$t('layout.menus[9]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/classes" class="pl-2">
            <v-list-tile-action>
              <v-icon class="material-icons">class</v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="white--text f-12">{{$t('layout.menus[10]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/createclass" class="pl-2">
            <v-list-tile-action>
              <!-- <v-icon class="white--text">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
            </v-list-tile-action>
            <v-list-tile-title class="white--text">{{$t('layout.menus[11]')}}</v-list-tile-title>
          </v-list-tile>

        </v-list-group>

        <v-list-group prepend-icon="view_module">
          <v-list-tile class="text-white" slot="activator">
            <v-list-tile-title class="text-white">{{$t('layout.menus[12]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/packages" class="pl-2">
            <v-list-tile-action>
              <v-icon class="white--text">fas fa-box</v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="white--text f-12">{{$t('layout.menus[13]')}}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile to="/createpackage" class="pl-2">
            <v-list-tile-action>
              <!-- <v-icon class="white--text">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
            </v-list-tile-action>
            <v-list-tile-title class="white--text f-12">{{$t('layout.menus[14]')}}</v-list-tile-title>
          </v-list-tile>

        </v-list-group>


        <v-list-tile to="/blocklist">
          <v-list-tile-action class="text-white">
            <v-icon>block</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white">{{$t('layout.menus[15]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/Settings">
          <v-list-tile-action class="text-white">
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white">{{$t('layout.menus[16]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/chatlist" class="hidden-lg-only">
          <v-list-tile-action class="text-white">
            <v-icon>chat_bubble</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white" >{{$t('layout.menus[17]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/testsignup" class="hidden-lg-only">
          <v-list-tile-action class="text-white">
            <v-icon>public</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white" >{{$t('layout.menus[18]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/adminprofile" class="">
          <v-list-tile-action class="text-white">
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="text-white" >{{$t('layout.menus[19]')}}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="out = true">
          <v-list-tile-action class="text-white">
            <!-- <v-icon>power_settings_new</v-icon> -->
            <i class="fas fa-sign-out-alt"></i>
          </v-list-tile-action>
          <v-list-tile-title class="text-white" >{{$t('layout.menus[20]')}}</v-list-tile-title>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="out" max-width="290">
      <v-card class="card-r">
        <v-card-title class="f-20 text-capitalize">Are You Sure Want To Logout?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="grey darken-2 text-white left card-r" text @click="out = false">No</v-btn>
          <v-btn class="primary darken-2 text-white card-r" text to="/logout">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap align-center>
      <v-flex class="text-xs-center" xs12 sm12 md12 lg12>
        <v-toolbar fixed class="tow-clor-1" app dark xs12>
          <v-toolbar-side-icon class="ml-2" @click.native.stop="sideNav = !sideNav"></v-toolbar-side-icon>
          <img  class="Toolbarlogo ml-1 hidden-xs-only" small src="/static/logo2.png"/>
          <v-toolbar-title class="white--text navTitle">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items >
            <v-flex xs12 class="searchBox ml-2 mr-2">
            <v-autocomplete
                v-model="selectedSearchString"
                :hint="!isEditing ? 'Click the icon to edit' : 'Click the icon to save'"
                :items="combinedData"
                persistent-hint
                flat
                :label="$t('layout.search_text')"
                item-text="name"
                item-value="id"
                prepend-inner-icon="search"
                solo-inverted
                @change="link"
            >

          <!--<template v-slot:append-outer>-->
            <!--<v-slide-x-reverse-transition-->
              <!--mode="out-in"-->
            <!--&gt;-->
              <!--<v-icon-->
                <!--:key="`icon-${isEditing}`"-->
                <!--:color="isEditing ? 'success' : 'info'"-->
                <!--@click="isEditing = !isEditing"-->
                <!--v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"-->
              <!--&gt;</v-icon>-->
            <!--</v-slide-x-reverse-transition>-->
          <!--</template>-->
        </v-autocomplete>
        </v-flex>
            <div class="hidden-xs-only">
              <v-flex xs12 class=" mr-3 ml-3 searchBox">
                <v-select
                  dark
                  solo
                  prepend-inner-icon="g_translate"
                  background-color="white"
                  class="text-grey f-12"
                  v-model="selectedLanguage"
                  @change="changeLanguage(selectedLanguage)"
                  :items="items"
                  item-text="language"
                  item-value="abbr"
                  label="Select"
                ></v-select>
              </v-flex>
            </div>
            <v-badge color="red" class="hidden-xs-only">
                <span v-if="unreadChatCount!=0" class="v-badge__badge">{{unreadChatCount}}</span>
              <v-btn icon to="/chat">
                <v-icon class="text-white f-25" >far fa-comment</v-icon>
              </v-btn>
            </v-badge>
            <v-badge color="red" class="hidden-xs-only">
              <span v-if="unreadNotiCount!=0" class="v-badge__badge">{{unreadNotiCount}}</span>
              <v-btn class="f-25" icon @click.stop="drawer = !drawer" @click="notificationSeen()">
                <v-icon class="text-white f-25">far fa-bell</v-icon>
              </v-btn>
            </v-badge>

            <!--<v-menu-->
              <!--v-model="menu"-->
              <!--:close-on-content-click="false"-->
              <!--:nudge-width="300"-->
              <!--offset-x-->
              <!--class="right"-->
            <!--&gt;-->
              <!--<v-btn icon slot="activator">-->
                <!--<v-icon class="navicon">public</v-icon>-->
              <!--</v-btn>-->

              <!--<v-card v-for="(n,index) in Notifications" v-bind:key="index">-->
                <!--<router-link to="/totalearnings">-->

                <!--<v-list to="/totalearnings">-->
                  <!--<v-list-tile avatar>-->
                    <!--<v-list-tile-avatar>-->
                    <!--<img :src="n.user_image" alt="John">-->
                    <!--</v-list-tile-avatar>-->
                    <!--<v-list-tile-content>-->
                      <!--<v-list-tile-title>{{n.message}} </v-list-tile-title>-->
                      <!--<v-list-tile-sub-title>{{n.time}}</v-list-tile-sub-title>-->
                    <!--</v-list-tile-content>-->
                  <!--</v-list-tile>-->
                <!--</v-list>-->
                <!--</router-link>-->
                <!--<v-divider></v-divider>-->
              <!--</v-card>-->
              <!--<v-flex v-if="Notifications.length!=0 && NextNotificationUrl!=null">-->
                <!--<div v-if="!notiLoading" @click="loadMoreNotifications" style="background-color:#0057a5;color:white;padding:2px 6px;text-align:center;">-->
                  <!--<button>Load More</button>-->
                <!--</div>-->
                <!--<div v-if="notiLoading" style="background-color:white;text-align:center;width:100%;padding:2px 10px;">-->
                  <!--<scale-loader :loading="true" color="#005daa" height="25px"></scale-loader>-->
                <!--</div>-->
              <!--</v-flex>-->
            <!--</v-menu>-->
            <div class="hidden-xs-only">
              <widset/>
            </div>
          </v-toolbar-items>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-navigation-drawer width="480" right overlay height="90vh"
                         class="pa-2 mb-3 card-r pb-4 shadow-1 grey lighten-4" fixed dark v-model="drawer">
      <!--<v-card >-->
      <v-toolbar class="primary darken-2 card-r pl-3 mb-3 text-white">
        <div class="text-xs-left f-20">Notifications</div>
        <v-spacer></v-spacer>
        <v-btn class="mr-3 primary darken-2 green right" icon @click="drawer = false">
          <v-icon class="text-white f-28">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card v-for="(Admin,index) in Notifications" :key="Admin.id" class="white card-r mb-2">
        <v-list >
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-img v-bind:src="Admin.user_image"> </v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="f-15 text-primary font-weight-medium">{{Admin.message}}</v-list-tile-title>
              <v-list-tile-sub-title class="f-12 grey--text">
                <span>{{Admin.date}}</span><v-spacer></v-spacer><span class="grey--text"> {{Admin.time}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!--<v-divider class="grey lighten-5"></v-divider>-->
      </v-card>
      <v-flex v-if="Notifications.length!=0 && NextNotificationUrl!=null">
        <div v-if="!notiLoading" @click="loadMoreNotifications" class="card-r py-2 text-xs-center text-white primary darken-2">
          <button>Load More</button>
        </div>
        <div v-if="notiLoading" style="background-color:white;text-align:center;width:100%;padding:2px 10px;">
          <scale-loader :loading="true" color="#005daa" height="25px"></scale-loader>
        </div>
      </v-flex>
      <!--</v-card>-->
    </v-navigation-drawer>
    <v-content>
      <router-view/>
    </v-content>
  </div>
</template>
<script>
/* eslint-disable */
import Addclasses from './pages/AddClasses'
import Widset from './pages/Widset'
import router from '../router'
import { mapState, dispatch } from "vuex";
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import api from "@/utils/backend-api"
// import {i18n} from "@/utils/i18n.js"

export default {
  name: "Dashboard",
  data: () => ({
    notiLoading:false,
    out : false,
    selectedLanguage:'en',
    drawer: false,
    items: [
      { language: 'English ', abbr: 'en' },
      { language: 'Chinese', abbr: 'ch' },
      { language: 'Hindustani ', abbr: 'NhiE' },
      { language: 'Spanish ', abbr: 'sp' },
      { language: 'Malay  ', abbr: 'ma' },
      { language: 'Russian ', abbr: 'ru' },
      { language: 'Bengali  ', abbr: 'be' },
      { language: 'Danish ', abbr: 'da' },
      { language: 'தமிழ் ', abbr: 'ta' },
      { language: 'Arabic ', abbr: 'ar' }
    ],
    isEditing: true,
    model: null,
    states: [
      'Alabama', 'Alaska', 'American Samoa', 'Arizona',

    ],
    teacherData:'',
    studentData:'',
    combinedData:[],
    fav: true,
    selectedSearchString:'',
    menu: false,
    message: false,
    hints: true,
    sideNav: false,
    admins: [
      ['Management', 'people'],
      ['Settings', 'settings']
    ],
    cruds: [
      ['Create', 'add'],
      ['Read', 'insert_drive_file'],
      ['Update', 'update'],
      ['Delete', 'delete']
    ],
    searchname: [
      'Nayanan ', 'Danny', 'lavan', 'sanjeeven','voranzo', 'sivarubini' , 'das', 'jerushan' , 'thilan'
    ],
    search:'',
    sideNavList: [

      {
        title: "Classes",
        path: "classes"
      },
      {
        title: "Add New Class",
        path: "createclass"
      },
      {
        title: "Packages",
        path: "Packages"
      },
      {
        title: "Add New Package",
        path: "createpackage"
      },

    ],
    unreadNotiCount:0,
    unreadChatCount:0
  }),
  created() {
    this.getChatCounts()
    let MenuList=this.$t('layout.menus')
        let lang=localStorage.getItem('heyway_lang')
        if(lang){
          let langList=['en','da','ar','be','ch','hi','ma','ru','ta']

          for(let x=0;x<langList.length;x++){
            if(lang==langList[x]){
              this.changeLanguage(lang)
            }
          }
        }else{
          this.changeLanguage('en')
        }
        Store.dispatch('getStudentData')
        Store.dispatch('getTeacherData')
        Store.dispatch('Notifications/getAllNotifications')
        setTimeout(() => {
          this.studentData = Store.state.studentData;
          this.teacherData = Store.state.teacherData;
          this.combinedData = this.studentData.concat(this.teacherData);
        }, 2500);
    },
   computed: {
    ...mapState({
      Notifications: Notifications => Store.state.Notifications.Notifications,
      NextNotificationUrl: Notifications => Store.state.Notifications.NextNotificationUrl,
      Teachers: Teachers => Store.state.Teachers.Teachers,
      // Students: Students => Store.state.Students.Students,
    })
  },
  methods:{
    notificationSeen(){
      let self=this
      console.log("notificationSeen()")
      api.postData('markNotificationAsSeen',{notification_id:this.Notifications[0].id})
      .then(res=>{
        self.getChatCounts()
      })
    },
    getChatCounts(){
      let self=this
      api.postData('admin/getUnreadMessageCount')
      .then(res=>{
        self.unreadChatCount=res.data.total_unread_message
        self.unreadNotiCount=res.data.total_unread_notification
      })
    },
    changeLanguage(language){
      localStorage.setItem('heyway_lang',language)
      this.selectedLanguage=language
      this.$i18n.locale=language
    },
    loadMoreNotifications(){
      this.notiLoading=true
      console.log("loadMoreNotifications")
      Store.dispatch('Notifications/callNextNotifications')
      setTimeout(()=>{
        this.notiLoading=false
      },1000);
    },
    link(){

      // setTimeout(() => {
        for(var x=0;x<this.combinedData.length;x++){
          if(this.combinedData[x].id==this.selectedSearchString){
            var usertype=this.combinedData[x].role
            switch(usertype){
              case "student":
                    this.$router.push('/studentprofile/'+this.combinedData[x].id)
                    Store.dispatch("Students/getStudentById",this.combinedData[x].id)
                    this.selectedSearchString=""
                    break;
              case "teacher":
                    this.$router.push('/teacherprofile/'+this.combinedData[x].id)
                    Store.dispatch("Teachers/getTeacherById",this.combinedData[x].id)
                    this.selectedSearchString=""

                    break;


            }
            break
          }
        }
      // this.$router.push('/studentprofile/1')
// }, 3500);
    }

  },

  components: {
    Addclasses,
    Widset,
    ScaleLoader
  }

};
</script>
<style lang="stylus" scoped>
  .v-toolbar__items .v-btn:not(.v-btn--floating):not(.v-btn--icon), .v-toolbar__items .v-menu, .v-toolbar__items .v-menu__activator {
    height: unset;
  }
/*  ::-webkit-scrollbar {
    display: none!important;
  }*/
  .v-icon{
    font-size: 17px !important;
  }
  .fa, .fas, .far, .fal, .fab{
    font-size 15px !important
  }
  .v-menu__content {
    top: 50px!important;
    right: 0px!important;
  }
  /* iPads (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    .v-menu__content {
      top: 50px!important;
      left: 205px!important
    }
  }

  /* iPads (landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .v-menu__content {
      top: 50px!important;
      left: 205px!important
    }
  }

  /* iPads (portrait) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
    .v-menu__content {
      top: 50px!important;
      left: 205px!important
    }
  }

  /* iPad 3 ---------------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .v-menu__content {
      top: 50px!important;
      left: 800px!important;
    }
  }
  @media only screen and (min-width: 960px) {
    .v-menu__content[data-v-aae30ed8] {
      top: 50px !important;
      /*left: 200px !important;*/
    }
  }

  /* Desktops and laptops ----------- */
  @media only screen and (min-width : 1224px) {
    .v-menu__content {
      top: 50px !important;
      left: 800px !important;
    }
  }

  /* 960px layouts ----------- */
  @media only screen and (min-width : 960px){
    .v-menu__content {
      top: 50px!important;
      left: 800px!important;
    }
  }

  /* Large screens ----------- */
  @media only screen and (min-width : 1824px) {
    .v-menu__content {
      top: 50px!important;
      left: 800px!important;
    }
  }
  :after, :before{
    // display:none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue